import React , {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
import {Link} from "react-router-dom";
import backIcon from './../../assets/images/icons/back-2.svg';
class OrderShowLoader extends Component{
    render(){
        return(
            <div>

                <div id="header-4">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row no-gutters justify-content-between">
                                        <div className="col-auto">
                                            <Link to="/order">
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="row no-gutters justify-content-center">
                                        <div className="col-auto">
                                            <div className="img-container">
                                                <Skeleton count={1} height={200} width={200} style={{position:"relative" , top:"-50px" , right : "-50px"}}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters justify-content-center mt-5">
                                        <div className="title">
                                            <Skeleton count={1} height={20} width={50}/>
                                        </div>
                                    </div>
                                    <div className="row no-gutters justify-content-center mt-2">
                                        <div className="sub-title">
                                            <Skeleton count={1} height={10} width={70}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        )
    }
}


export default OrderShowLoader;